import React, { ReactNode } from "react"

import classNames from "src/classNames"

export type PanelProps = {
  children: ReactNode
  className?: string
}

const Panel: React.FC<PanelProps> = ({ children, className }) => {
  return (
    <div
      className={classNames(
        "mb-4 rounded-lg border border-solid bg-white p-4 shadow",
        className
      )}
    >
      {children}
    </div>
  )
}

export default Panel
